<template>
    <div class="loader-container">
        <div class="spinner-text">Bild wird hochgeladen</div>
        <div class="spinner"></div>
    </div>
    <div id="planer-app">
        <router-view/>
    </div>


</template>

<style>
:root {
    --popper-theme-background-color: #333333;
    --popper-theme-background-color-hover: #333333;
    --popper-theme-text-color: #ffffff;
    --popper-theme-border-width: 0px;
    --popper-theme-border-style: solid;
    --popper-theme-border-radius: 6px;
    --popper-theme-padding: 10px;
    --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}




.s-lbl {
  margin-bottom: 10px;
}


.s-slider {
  position: relative;
  overflow: hidden;
  height: 400px;
}

.s-left, .s-right {
    position: absolute;
    top: 16%;
    left: 100px;
    width: 60px;
    height: 60px;
    cursor: pointer;
    text-align: center;
}

.s-left img, .s-right img {
    width: 15px;
    height: auto;
}

.cover-layer-text {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.cover-layer-text span {
    position: absolute;
}

.cover-holder {
    position: relative;
}

.cover-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.s-right {
    right: 125px;
    left: auto;
}

.s-layer {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
    text-align: center;
}

.s-layer img {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
}

.s-slider-base {
    height: 100%;
    text-align: center;
}

.s-slider-base img {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
}


.cover-holder img {
  width: 370px;
  height: auto;
}

.s-nav a {
  width: 160px;
  padding: 10px 0;
  border-radius: 5px;
  background-color: black;
  display: inline-block;
  text-align: center;
  color: white;
  text-decoration: none;
}

.btn-round{
  border-radius: 30px;
  background-color: black;
  color: white;
  padding: 5px 30px;
  }
  .no-hover:hover{
    background-color: black !important;
    color: white !important;
    }
  .width-5{
    width: 50%;
  }
  .width-10{
    width: 100%;
    }
  .width-7{
    width: 70%;
    }
  .marg-center{
    margin: 0 auto;
  }
  .height-5{
    height: 50px;
  }
  .mr-1{
    margin-right: 10px;
  }
  .width-65{
    width: 65%;
  }
  .back-btn{
    background-color: white !important;
    color: grey !important;
    border: 1px solid grey;
  }
  .grey{
    color: grey;
    }

  .check-black:checked{
    background-color: black;
    border-color: black;

  }
</style>
<script setup>
</script>
